export default __webpack_public_path__ + "static/media/apm.96f9864e.jpg";